module.exports = __webpack_public_path__ + "media/images/icons/verified-seller-7e625728204a1b40d06aa237d15560b1.svg";